import BlockContainer from "../../mainPageBlocks/blockContainer";
import CustomCarousel from "../../ui/customCarousel";
import { PARTNERS } from "../constants";

import styles from "./styles.module.scss";

const responsive = {
  mobile: {
    breakpoint: { max: 768, min: 360 },
    items: 1,
    slidesToSlide: 1,
    partialVisibilityGutter: 65,
  },
};

const ParnersBlock = () => {
  const getPartnersList = () => {
    return PARTNERS.map((partner, i) => (
      <div key={i} className={styles.ParnersBlock_list__partner}>
        <img src={partner.img} alt={partner.alt} />
        <p>{partner.text}</p>
      </div>
    ));
  };

  return (
    <section className={styles.Container}>
      <div className="container">
        <div className={styles.ParnersBlock}>

          <h2>Спасибо всем, без кого бы этого проекта не было</h2>

          <div className={styles.ParnersBlock_list}>
            { getPartnersList() }
          </div>

          <div className={styles.ParnersBlock_listMobile}>
            <BlockContainer marginBottom={"0px"}>
              <CustomCarousel
                swipeable={true}
                draggable={false}
                minimumTouchDrag={70}
                removeArrowOnDeviceType={["mobile"]}
                responsive={responsive}
                infinite
                partialVisible={false}
                autoPlay
              >
                { getPartnersList() }
              </CustomCarousel>
            </BlockContainer>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ParnersBlock;
